module.exports = __webpack_public_path__ + "static/GraphiQL-alerts-9a38508ba4be2aef0a4aeff43bda515d.png";